package com.macrofocus.eflux

import com.macrofocus.eflux.context.ActiveTooltip
import com.macrofocus.eflux.network.LinkField
import com.macrofocus.eflux.network.NodeField

enum class ViewStyle {
    FLOW {
        override val classname: String = "flow"

        override fun apply(configuration: EFluxConfiguration) {
            configuration.colorNodes.value = null
            configuration.thicknessLinks.value = LinkField.p
            configuration.activeTooltips.value = ActiveTooltip.Links

            configuration.movementLinks.value = LinkField.pratea
            configuration.animationLinks.value = true

            configuration.logicalBusProbing.clearSelection()
            configuration.logicalBusSelection.clearSelection()
        }

        override fun toString(): String {
            return "Power flow"
        }
    },

    VOLTAGE {
        override val classname: String = "voltage"

        override fun apply(configuration: EFluxConfiguration) {
            configuration.colorNodes.value = NodeField.v
            configuration.thicknessLinks.value = null
            configuration.activeTooltips.value = ActiveTooltip.Nodes

            configuration.movementLinks.value = null
            configuration.animationLinks.value = false

            configuration.logicalBranchProbing.clearSelection()
            configuration.logicalBranchSelection.clearSelection()
        }

        override fun toString(): String {
            return "Voltage"
        }
    },

    COMBINED {
        override val classname: String = "combined"

        override fun apply(configuration: EFluxConfiguration) {
            configuration.colorNodes.value = NodeField.v2
            configuration.thicknessLinks.value = LinkField.p
            configuration.activeTooltips.value = ActiveTooltip.Both

            configuration.movementLinks.value = LinkField.pratea
            configuration.animationLinks.value = true
        }

        override fun toString(): String {
            return "Combined"
        }
    };

    abstract val classname : String
    abstract fun apply(configuration: EFluxConfiguration)
}